import React, { useContext, memo, useMemo, useCallback } from "react";
import WidgetCard from "./WidgetCard";
import { TiLocationArrowOutline } from "react-icons/ti";
import EChartsReact from "echarts-for-react";
import AppContext from "context/Context";
import { useDispatch } from 'react-redux';
import { openModal } from "slices/stillageWidgetModalSlice";
import { capitalize } from "helpers/utils";
import { getColor } from "helpers/utils";
import { isStillageAtEmplas } from "services/stillageDashboard";
import PropTypes from 'prop-types';

const Locations = ({ data, loading }) => {
    const {
        config: { isDark }
    } = useContext(AppContext);
    const dispatch = useDispatch();

    const colours = [getColor('primary'), getColor('success')];
    const siteCounts = useMemo(() =>
        data?.reduce((acc, curr) => {
            const addCount = (acc, curr, key) => {
                acc[key] = [...acc[key] || [], curr];
                return acc;
            }
            return addCount(acc, curr, isStillageAtEmplas(curr.lat, curr.long, curr.stillageNo) ? "on_Site" : "off_Site");
        }, {}), [data]);
    const chartData = useMemo(() => Object.entries(siteCounts ?? []).map(([name, value]) => (
        {
            name: capitalize(name.split('_').join(' ')),
            value: value?.length || 0,
            itemStyle: {
                color: name === 'off_Site' ? colours[1] : colours[0],
            },
        })), [siteCounts]);

    const handleClick = useCallback(params => {
        const { name } = params;
        const key = name[0]?.toLowerCase() + name?.slice(1)?.replace(' ', '_');
        if (!key) return;

        dispatch(openModal({ title: name, data: siteCounts[key] || [], loading }));
    }, [data, siteCounts, dispatch, loading]);

    return (
        <>
            <WidgetCard title="On Site Vs Off Site (Trackers)" icon={<TiLocationArrowOutline />} loading={loading}>
                <EChartsReact
                    onEvents={{
                        'click': params => handleClick(params)
                    }}
                    option={{
                        title: { show: false },
                        legend: {
                            orient: 'vertical',
                            left: 'left',
                            height: '100%',
                            top: 'center',
                            textStyle: {
                                color: getColor('500')
                            }
                        },
                        tooltip: {
                            show: false,
                        },
                        series: [{
                            type: 'pie',
                            label: {
                                show: false,
                                position: 'center',
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontWeight: 'bold',
                                    formatter: '{c}',
                                }
                            },
                            radius: ['50%', '70%'],
                            center: ['80%', '50%'],
                            name: 'item',
                            data: chartData,
                        }],
                        darkMode: isDark
                    }}
                    style={{ height: '6rem' }}
                />
            </WidgetCard>
        </>
    )
}

Locations.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
}

export default memo(Locations);